<template>
	<div>
		<div class="shop-index" v-loading="loading">
			<div class="shop-left">
				<div class="shop-wrap">
					<div class="head-wrap">
						<div class="img-wrap">
							<img class="img-responsive center-block"
								:src="shopInfo.avatar ? $img(shopInfo.avatar) : $img(defaultShopImage)"
								@error="shopInfo.avatar = defaultShopImage" :alt="shopInfo.site_name" />
						</div>
						<h5>
							<span class="ns-text-color">{{ shopInfo.site_name }}</span>
							<el-tag class="tag" size="small" v-if="shopInfo.is_own == 1">自营</el-tag>
						</h5>
					</div>
					<div class="info-wrap">
						<div class="item">
							描述相符
							<b>{{ shopInfo.shop_desccredit }}</b>分
						</div>
						<div class="item">
							服务态度
							<b>{{ shopInfo.shop_servicecredit }}</b>分
						</div>
						<div class="item">
							发货速度
							<b>{{ shopInfo.shop_deliverycredit }}</b>分
						</div>
					</div>
					<div class="other-info" v-if="shopInfo.full_address">
						<!-- <div class="tell" v-if="shopInfo.telephone">
                            <div class="tell-name">电话:</div>
                            <div class="tell-detail">{{shopInfo.telephone}}</div>
                        </div> -->
						<div class="item-info">
							<div class="item-name">地址:</div>
							<div class="item-detail">{{shopInfo.full_address}}{{shopInfo.address}}</div>
						</div>
					</div>
					<div class="operation">
						<el-button size="medium" @click="getIsFollow" v-if="hasFollow">取消关注</el-button>
						<el-button size="medium" @click="getIsFollow" v-else>关注店铺</el-button>
					</div>
				</div>
				<div class="shop-goods-search">
					<el-input placeholder="搜索 商品" v-model="keyword" class="input-with-select" size="medium"
						maxlength="50" clearable>
						<el-button slot="append" icon="el-icon-search" @click="goGoodsList"></el-button>
					</el-input>
				</div>
				<div class="shop-goods-cate" :class="{border:categoryList.length}">
					<div class="item" v-for="item in categoryList" :key="item.category_id">
						<div class="menu-name"
							@click="$router.push({ path: '/shop_list', query: { site_id: id, shop_category_id: item.category_id } })">
							{{ item.category_name }}
						</div>
						<div class="submenu" v-for="cate in item.child_list" :key="cate.category_id"
							@click="$router.push({ path: '/shop_list', query: { site_id: id, shop_category_id: item.category_id} })">
							{{ cate.category_name }}
						</div>
					</div>
				</div>
			</div>
			<div class="shop-right">
				<div class="content" style="padding:0 1%">
					<h4>基本信息</h4>
					<div class="jianjie">
						<div class="sh" :style="{background:'url('+dp2img.url+') center no-repeat #fff'}">
							<h2>{{ shopInfo.site_name }} </h2>
							<ul :style="{background:'url('+biaoqianimg.url+') center no-repeat'}">
								<li>入驻：<span>{{shopInfo.year}}年</span></li>
								<li>访客：<span>{{shopInfo.click_count}}</span></li>
								<li>销量：<span>{{shopInfo.shop_sales}}</span></li>
								<li>关注：<span>{{shopInfo.sub_num}}</span></li>
							</ul>
							<div class="pingx">
								<span>店铺星级：</span>
								<div>
									<img v-if="shopInfo.rank >= 1" src="@/assets/styles/images/xq44.png" alt="">
									<img v-if="shopInfo.rank >= 2" src="@/assets/styles/images/xq44.png" alt="">
									<img v-if="shopInfo.rank >= 3" src="@/assets/styles/images/xq44.png" alt="">
									<img v-if="shopInfo.rank >= 4" src="@/assets/styles/images/xq44.png" alt="">
									<img v-if="shopInfo.rank >= 5" src="@/assets/styles/images/xq44.png" alt="">
								</div>
							</div>
							<p>所属产业链：{{shopInfo.industry_name}}</p>
							<p>主营类型：{{shopInfo.goodscategory_name}}</p>
						</div>
					</div>
					<h4>商家简介</h4>
					<!--文本编辑器-->
					<div class="xia" v-html="shopInfo.seo_description"></div>
					<h4>资质信息</h4>
					<div class="zizhi">
						<ul>
							<li v-if="!$util.isEmpty(cert_info.business_licence_number_electronic)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image
										:preview-src-list="[$util.img(cert_info.business_licence_number_electronic)]"
										:src="$util.img(cert_info.business_licence_number_electronic)" title="营业执照"
										alt="营业执照"></el-image>
								</div>
								<p>营业执照</p>
							</li>
							<!-- <li v-if="!$util.isEmpty(cert_info.tax_registration_certificate_electronic)">
                                <div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}" > 
                                    <img :src="$util.img(cert_info.tax_registration_certificate_electronic)" title="税务登记证" alt="税务登记证"> 
                                </div>
                                <p>税务登记证</p>
                            </li> -->
							<li v-if="!$util.isEmpty(a_quality_inspection_report)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<!-- <el-image :preview-src-list="[$util.img(cert_info.quality_inspection_report)]"
										:src="$util.img(cert_info.quality_inspection_report)" title="质检报告" alt="质检报告">
									</el-image> -->
									<el-image :preview-src-list="a_quality_inspection_report"
										:src="a_quality_inspection_report[0]" title="质检报告" alt="质检报告">
									</el-image>
								</div>
								<p>质检报告</p>
							</li>
							<li v-if="!$util.isEmpty(cert_info.health_quarantine_certificate)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image :preview-src-list="[$util.img(cert_info.health_quarantine_certificate)]"
										:src="$util.img(cert_info.health_quarantine_certificate)" title="农产品卫生检疫合格证明"
										alt="农产品卫生检疫合格证明"> </el-image>
								</div>
								<p>农产品卫生检疫合格证明</p>
							</li>
							<li v-if="!$util.isEmpty(cert_info.pollution_free_certification)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image :preview-src-list="[$util.img(cert_info.pollution_free_certification)]"
										:src="$util.img(cert_info.pollution_free_certification)" title="无公害农产品认证"
										alt="无公害农产品认证"> </el-image>
								</div>
								<p>无公害农产品认证</p>
							</li>
							<li v-if="!$util.isEmpty(cert_info.geography_certificate)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image :preview-src-list="[$util.img(cert_info.geography_certificate)]"
										:src="$util.img(cert_info.geography_certificate)" title="农产品地理标志登记证书"
										alt="农产品地理标志登记证书"> </el-image>
								</div>
								<p>农产品地理标志登记证书</p>
							</li>
							<li v-if="!$util.isEmpty(cert_info.green_certificate)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image :preview-src-list="[$util.img(cert_info.green_certificate)]"
										:src="$util.img(cert_info.green_certificate)" title="绿色食品认证证书" alt="绿色食品认证证书">
									</el-image>
								</div>
								<p>绿色食品认证证书</p>
							</li>
							<li v-if="!$util.isEmpty(cert_info.organic_certificate)">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image :preview-src-list="[$util.img(cert_info.organic_certificate)]"
										:src="$util.img(cert_info.organic_certificate)" title="有机食品认证" alt="有机食品认证">
									</el-image>
								</div>
								<p>有机食品认证</p>
							</li>

							<li v-for="item in foodimglist" :key="item">
								<div class="tu" :style="{background:'url('+dp3img.url+') no-repeat center'}"
									@contextmenu.prevent>
									<el-image :preview-src-list="[$util.img(item)]" :src="$util.img(item)"
										title="食品生产/经营许可证" alt="食品生产/经营许可证"> </el-image>
								</div>
								<p>食品生产/经营许可证</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		shopInfo,
		isFollow,
		unFollow,
		follow,
		tree
	} from "@/api/shop/index";
	import {
		goodsSkuPage
	} from "@/api/goods/goods";
	import {
		mapGetters
	} from "vuex";
	import {
		adList
	} from "@/api/website";
	export default {
		name: "shop_info",
		components: {},
		data: () => {
			return {
				id: 0,
				currentPage: 1,
				pageSize: 12,
				shopInfo: {}, //店铺信息
				hasFollow: false, //是否关注
				searchContent: "",
				categoryList: [],
				goodsList: [],
				total: 0,
				loading: true,
				keyword: "",
				adList: [],
				foodimglist: [],
				cert_info: {},
				a_quality_inspection_report: [],
				biaoqianimg: {
					url: require('@/assets/styles/images/biaoqian.png'),
				},
				dp2img: {
					url: require('@/assets/styles/images/dp2.png'),
				},
				dp3img: {
					url: require('@/assets/styles/images/dp3.png'),
				},
			};
		},
		computed: {
			...mapGetters([
				"token",
				"defaultShopImage",
				"addonIsExit",
				"defaultGoodsImage"
			])
		},
		created() {
			this.id = this.$route.query.site_id;
			this.getAdList();
			this.getShopInfo();
			this.getCategoryList();
			this.getGoodsList();
			this.getfollow();
		},
		watch: {
			$route(curr) {
				this.id = curr.params.pathMatch;
				this.getAdList();
				this.getShopInfo();
				this.getCategoryList();
				this.getGoodsList();
				this.getfollow();
			}
		},
		methods: {
			// MM() {
			// 	if (event.srcElement.id == 'an') //判断右击事件发生在哪个对像上面
			// 	{
			// 		alert("对不起，本图片不能复制，版权所有！")
			// 		document.oncontextmenu = new Function("event.returnValue=false;"); //禁用右键功能
			// 	} else {
			// 		document.oncontextmenu = new Function("event.returnValue=true;"); //启用右键功能
			// 	}
			// }, 
			getAdList() {
				adList({
						keyword: "NS_PC_SHOP_INDEX"
					})
					.then(res => {
						this.adList = res.data.adv_list;
						for (let i = 0; i < this.adList.length; i++) {
							if (this.adList[i].adv_url)
								this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url);
						}
					})
					.catch(err => err);
			},
			//获取店铺信息
			getShopInfo() {
				shopInfo({
						site_id: this.id
					})
					.then(res => {
						if (res.code == 0) {
							this.shopInfo = res.data;
							this.cert_info = this.shopInfo.cert_info;
							if (!util.isEmpty(this.cert_info.quality_inspection_report)) {
								var t_data = this.cert_info.quality_inspection_report.split('|');
								t_data.forEach(function(item, index) {
									t_data[index] = util.img(item)
								})
								this.a_quality_inspection_report = t_data
							}
							if (!util.isEmpty(this.cert_info.food_production_certificate)) {
								this.foodimglist = this.cert_info.food_production_certificate.split('|');
							}
						}
					})
					.catch(err => {
						this.loading = false;
						this.$message.error(err.message);
					});
			},
			//获取店铺商品分类列表
			getCategoryList() {
				tree({
						site_id: this.id
					})
					.then(res => {
						this.categoryList = res.data;
					})
					.catch(err => {
						this.loading = false;
						this.$message.error(err.message);
					});
			},
			//获取店铺商品列表
			getGoodsList() {
				const params = {
					page: this.currentPage,
					page_size: this.pageSize,
					site_id: this.id,
					keyword: this.keyword,
					sort: "desc"
				};
				goodsSkuPage(params || {})
					.then(res => {
						if (res.code == 0 && res.data) {
							let data = res.data;
							this.goodsList = data.list;
							this.total = res.data.count;
							this.loading = false;
						}
					})
					.catch(err => {
						this.loading = false;
						this.$message.error(err.message);
					});
			},
			//获取店铺关注信息
			getfollow() {
				isFollow({
						site_id: this.id
					})
					.then(res => {
						this.hasFollow = res.data;
					})
					.catch(err => {});
			},
			//关注与取消
			getIsFollow() {
				if (util.isEmpty(this.token)) {
					// this.$message({
					//   message: "您还未登录，请先登录！",
					//   type: "warning"
					// });
					location.href = '/login?redirect=' + this.$route.fullPath;
					return;
				}
				if (this.hasFollow) {
					unFollow({
						site_id: this.id
					}).then(res => {
						if (res.code == 0 && res.data) {
							this.hasFollow = !this.hasFollow;
							this.$message({
								message: "取消关注成功",
								type: "success"
							});
						}
					});
				} else {
					follow({
						site_id: this.id
					}).then(res => {
						if (res.code == 0) {
							this.hasFollow = !this.hasFollow;
							this.$message({
								message: "关注成功",
								type: "success"
							});
						}
					});
				}
			},
			goGoodsList() {
				this.$router.push({
					path: "/shop_list",
					query: {
						site_id: this.id,
						keyword: this.keyword
					}
				});
			},
			handlePageSizeChange(num) {
				this.pageSize = num;
				this.getGoodsList();
			},
			handleCurrentPageChange(page) {
				this.currentPage = page;
				this.getGoodsList();
			},
			imageError(index) {
				this.goodsList[index].sku_image = this.defaultGoodsImage;
			}
		}
	};
</script>
<style lang="scss" scoped>
	.el-carousel__item.is-active {
		z-index: 0;
	}

	.shop-index {
		padding-top: 10px;
		display: flex;
		background-color: #ffffff;

		.shop-left {
			width: 234px;

			.shop-wrap {
				width: 191px;
				float: right;
				border: 1px solid #eeeeee;
				padding: 0 21px;

				.head-wrap {
					text-align: center;
					padding: 10px 0;
					border-bottom: 1px solid #eeeeee;

					.img-wrap {
						width: 60px;
						height: 60px;
						line-height: 60px;
						display: inline-block;
					}

					.tag {
						margin-left: 5px;
					}

				}

				.info-wrap {
					padding: 10px;
					color: #838383;

					b {
						color: #383838;
					}

					border-bottom: 1px solid #eeeeee;
				}

				.other-info {
					padding: 10px;
					color: #838383;

					.item-info {
						display: flex;

						.item-name {
							width: 75px;
						}

					}

					.tell {
						display: flex;

						.tell-name {
							width: 35px;
						}

					}
				}

				.operation {
					border-top: 1px solid #eeeeee;
					padding: 10px 0;
					text-align: center;
				}

			}

			.shop-goods-search {
				.el-input {
					margin: 10px 0;
				}

			}

			.border {
				border: 1px solid #f1f1ff;
			}

			.shop-goods-cate {
				width: 100%;

				.menu-name {
					padding-left: 16px;
					background: #f8f8f8;
					font-size: $ns-font-size-base;
					height: 40px;
					cursor: pointer;
					color: #666666;
					display: flex;
					align-items: center;
				}

				.submenu {
					font-size: $ns-font-size-base;
					line-height: 2;
					border-top: 1px solid #f1f1f1;
					padding-left: 26px;
					cursor: pointer;
					display: flex;
					align-items: center;
					height: 40px;
					background: #ffffff;
					color: #666666;
				}

			}
		}

		.shop-right {
			margin-left: 26px;
			width: 100%;

			.shop-banner {
				width: 100%;
			}

			.tj {
				text-align: center;
				font-size: 30px;
				margin-top: 10px;
			}

			.goods-info {
				margin-top: 5px;
				display: flex;
				flex-wrap: wrap;

				.item {
					width: 200px;
					margin: 10px 20px 0 0;
					border: 1px solid #eeeeee;
					padding: 10px;
					position: relative;

					&:nth-child(4n) {
						margin-right: initial !important;
					}

					&:hover {
						border: 1px solid $base-color;
					}

					.img-wrap {
						width: 198px;
						height: 198px;
						cursor: pointer;
					}

					.goods-name {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						cursor: pointer;

						&:hover {
							color: $base-color;
						}

					}

					.price-wrap {
						display: flex;

						.price {
							display: flex;
							color: $base-color;
							font-size: $ns-font-size-lg;

							p {
								font-size: $ns-font-size-base;
								display: flex;
								align-items: flex-end;
							}

						}

						.market-price {
							color: #838383;
							text-decoration: line-through;
							margin-left: 15px;
						}

					}

					.promotion_type {
						position: absolute;
						top: 0;
						right: 0;
						color: #ffffff;
						background: $base-color;
						border-bottom-left-radius: 10px;
						padding: 3px 8px;
						line-height: 1;
						font-size: $ns-font-size-sm;
					}

				}
			}

			.page {
				display: flex;
				justify-content: center;
				align-content: center;
				padding-top: 20px;
			}

		}
	}


	.jianjie {
		width: 100%;
		margin: auto
	}

	.jianjie .sh {
		width: 60%;
		background-size: 100%;
		border-radius: 10px;
		box-shadow: 0px 3px 54px 0px rgba(0, 0, 0, 0.13);
		padding: 2% 2%;
		text-align: left
	}

	.jianjie .sh ul {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		margin-bottom: 10px;
		background-size: 100%;
		padding: 20px 0
	}

	.jianjie .sh ul li {
		margin-right: 20px;
		color: #666
	}

	.jianjie .sh ul li span {
		color: #39bf3e
	}

	.jianjie .sh .pingx {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 10px
	}

	.jianjie .sh .pingx span {
		color: #666;
	}

	.jianjie .sh .pingx div img {
		margin-right: 10px;
	}

	.jianjie .sh h2 {
		font-size: 18px;
		color: #333;
		margin-bottom: 20px;
	}

	.jianjie .sh h2 span {
		font-size: 14px;
		background: #39bf3e;
		padding: 2px 10px;
		border-top-left-radius: 10px;
		border-bottom-right-radius: 10px;
		color: #fff
	}

	.jianjie .sh p {
		font-size: 14px;
		color: #666;
		margin-bottom: 10px
	}

	.jianjie .xia {
		font-size: 14px;
		color: #666;
		line-height: 30px;
		text-align: left;
		margin-top: 20px
	}

	.zizhi {
		width: 100%;
	}

	.zizhi ul {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap
	}

	.zizhi ul li {
		width: 33%;
		height: 240px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-bottom: 1%
	}

	.zizhi ul li .tu {
		width: 86%;
		height: 86%;
		overflow: hidden;
		background-size: 100% !important;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 3% 4%;
	}

	.zizhi ul li .tu .el-image {
		width: 100%;
		display: block;
		height: 100%;
	}

	.zizhi ul li .tu .el-image img {
		width: 100%;
		display: block;
		height: 100%;
	}

	.zizhi ul li p {
		margin-top: 4px;
	}

	.content h4 {
		position: relative;
		height: 35px;
		padding-right: 10px;
		font-size: 14px;
		padding-left: 14px;
		font-weight: bold;
		color: #333;
		margin: 10px 0px;
	}

	.content h4:before {
		content: "";
		width: 4px;
		height: 20px;
		background: #39bf3e;
		border-radius: 20px;
		position: absolute;
		left: 0;
		top: 0
	}
</style>
